{
    "IncludeintransitioningsequenceLabel": "Incluir na sequência de apresentação de transição do relatório:",
    "RptdisplintervaltimeLabel": "Tempo de intervalo de apresentação do relatório:",
    "RptdisplintervaltimePlaceholder": "5s",
    "DisplaySwitching_SectionHeader": "Alternância automática de visualização de relatórios",
    "NAME": "DisplaySwitching"
}